import React from 'react';
import { useStyletron } from 'baseui';
import { StyledDivider } from 'baseui/divider';
import type { AnnotationLabelT, RangeSpanT } from '../../../../../../common/types/types';
import type { TimeDisplayMode } from '../../../../../types';
import type { PROPAGATION_METHOD } from '../../../../reducers/actions';
import { AddSequenceSection } from './annotation-timeline-config-sub-components/add-sequence-section';
import { AnnotationHeader } from './annotation-timeline-config-sub-components/annotation-header';
import { ExistingSequences } from './annotation-timeline-config-sub-components/existing-sequences';
export type AnnotationTimelineConfigPropsT = {
  annotationId: string;
  annotationLabel: AnnotationLabelT;
  currentFrame: number;
  maxFrames: number;
  hasManualKeyFrameInRange: (start: number, end: number) => boolean;
  annotationSequence: Map<string, RangeSpanT>;
  onPropagationMethodChange: (propagationMethod: (typeof PROPAGATION_METHOD)[keyof typeof PROPAGATION_METHOD]) => void;
  Icon?: (a: {
    strokeColor?: string;
  }) => React.ReactNode;
  onChange: (annotationSequence: Map<string, RangeSpanT>, isAnnotationTracking?: boolean) => Promise<void>;
  actionConfig?: string[];
  setTrackedSequence?: (sequence: {
    start: number;
    end: number;
    annotationId: string;
  } | null) => void;
  timeDisplayMode: TimeDisplayMode;
  frameRate: number | null | undefined;
  onClose?: () => void;
};
export const AnnotationTimelineConfig = (props: AnnotationTimelineConfigPropsT) => {
  const [css, theme] = useStyletron();
  return <div className={css({
    backgroundColor: theme.colors.backgroundPrimary,
    fontFamily: 'Uber Move'
  })}>
      <AnnotationHeader annotationId={props.annotationId} annotationLabel={props.annotationLabel} Icon={props.Icon} />
      <StyledDivider />
      <ExistingSequences annotationSequence={props.annotationSequence} timeDisplayMode={props.timeDisplayMode} frameRate={props.frameRate} maxFrames={props.maxFrames} />
      <AddSequenceSection {...props} />
    </div>;
};